import axios from "axios";
import { type Account } from "../types";

export async function fetchAccount() {
  const resp = await axios.get<Account>("/api/account");
  return resp.data;
}
